import axios from 'axios';
import { host } from '../host';

export default axios.create({
  baseURL: host,
});
// export default axios.create();
